export default {
  List: {
    Title: "Vị trí công việc",
    Search: "Tìm kiếm vị trí công việc",
    JobPositionCode: "Mã vị trí công việc",
    JobPositionName: "Tên vị trí công việc",
    JobTitle: "Chức danh",
    OrganizationUnitName: "Cơ cấu tổ chức",
    Description: "Ghi chú",
    SynchFromAMIS: "Đồng bộ từ AMIS",
    SynchFromAMISTitle: "Đồng bộ từ AMIS hệ thống",
    WorkingRun: "Đang thực hiện đồng bộ dữ liệu từ Amis hệ thống",
    SynchSuccess: "Đồng bộ thành công",
    SynchFalse: "Đồng bộ không thành công",
    IsUpdating: "Tính năng đang trong quá trình phát triển",
  },
  Detail: {
    OrganizationUnit: "Đơn vị công tác",
    Add: "Thêm mới vị trí công việc",
    Edit: "Sửa vị trí công việc",
    JobPositionInfo: "Thông tin vị trí công việc",
  },
};
